import React, { useEffect, useState } from "react";
import ModalPortal from "../../portal/ModalPortal";
import {
  ModalActionButtonWrapper,
  ModalStyle,
  Mymodal_wrapper,
  ModalButtons,
  Form,
  ModalTitle,
  SaveButtonModal,
  DeleteButtonModal,
  DeleteMessage,
} from "../../styles/MainLayout";
import axios from "../../axios";
import { toast } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';

import sign from "jwt-encode";


const TrainingLessonsModal = (props) => {

  console.log("training lessons props", process.env.REACT_APP_UPLOADS + props?.training?.video)

  const [isEdit, setEdit] = useState(false);
  const [isdelete, setDelete] = useState(false);
  const [trainingLessonCategories, setTrainingLessonCategories] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState(props?.item?.category || null);
  
  const [addTraining, setAddTraining] = useState({
    id: props?.dataToModal?.id,
    title_al: props?.dataToModal?.title_al
  });
  
  const getCategoryData = () => {
    axios.get('training-lessons-cat/all').then(data => {
      setTrainingLessonCategories(data.data);
    }).catch(err => {
      console.log('TrainingLessonCateErr', err)
    });
  };


  const addTrainingLesson = (e) => {
    e.preventDefault();

    const formData = new FormData();
  
    Object.keys(addTraining).forEach((key) => {
      formData.append(key, addTraining[key]);
    });
  
    // formData.append('video', addTraining.video?.name);
  
      e.preventDefault();
        axios.post('/training-lessons', formData)
          .then(data => {
            props?.handleModalClose();
            props?.getData();
            toast.success('Të dhënat janë ruajtur me sukses!');
          }
          ).catch(err => {
            toast.error('Të dhënat nuk janë ruajtur!');
            console.log(err);
          });
  };
  
  
  
  const editTrainingLesson = (e) => {
    e.preventDefault()

  
    const formData = new FormData();

    Object.keys(addTraining).forEach((key) => {
      formData.append(key, addTraining[key])
    })

    if (addTraining.newVideo) {
      formData.append('video', addTraining.newVideo)
    }

    axios.put(`/training-lessons`, formData)
      .then(data => {
        toast.success('Të dhënat  janë përditësuar me sukses!');
        props?.getData();
        props?.handleModalClose();
      }).catch(err => {
        console.log(err);
        toast.error('Të dhënat nuk janë përditësuar!');
      })
  }


  

  const deleteTrainingLesson = () => {
    axios.delete(`/training-lessons/${props?.dataToModal?.id}`).then(data => {
      toast.success('Të dhënat janë fshirë me sukses!');
      props?.handleModalClose();
      props?.getData();
    }).catch(err => {
      console.log(err);
      toast.success('Të dhënat  nuk janë fshirë me sukses!');
    })
  };


  const handleChange = (e) => {

    let secretKey = process.env.REACT_APP_SECRET;
    if (e.target.name == "password") {
      let encriptedPassword = sign(e.target.value, secretKey)
      setAddTraining({
        ...addTraining,
        [e.target.name]: encriptedPassword,
      });
    }
 
      else{
        setAddTraining({
          ...addTraining,
          [e.target.name]: e.target.value,
        })
      }
      console.log("addTraining", addTraining)
  }

  // console.log("addTraining", addTraining)

  const video = (e) => {
    const ud = Object.assign({}, addTraining);
    ud.training_lessons = e.target.files[0];
    setAddTraining(ud);
    // setSelectedName(ud?.url?.name);
    console.log("image data", ud)
  };

  
  useEffect(() => {
    getCategoryData();
  }, []);


  useEffect(() => {
    if (props?.isOpen) {
      setDelete(false);
    }
  }, [props?.isOpen]);
  
  
  if (props?.isOpen) {
    return (
      <>
        <ModalPortal>
          <ModalStyle>
            <div className="wholePage" onClick={() => props?.handleModalClose()}/>
            <Mymodal_wrapper>
              <ModalActionButtonWrapper>
                { props?.type !== "add" ?
                  <>
                    <ModalButtons delete onClick={() => setDelete(!isdelete)}>
                      <i className={isdelete ? "fa fa-times" : "fa fa-trash"} />
                    </ModalButtons>
                    <ModalButtons close onClick={() => props?.handleModalClose()}>
                      <i className={isdelete ? "fa fa-times" : "fa fa-times"} />
                    </ModalButtons>
                  </>
                  :   
                  <ModalButtons close onClick={() => props?.handleModalClose()}>
                    <i className={isdelete ? "fa fa-times" : "fa fa-times"} />
                  </ModalButtons>
                }
              </ModalActionButtonWrapper>
              {isdelete === false && (
                <Form>
                  <ModalTitle title>Add Training Lessons </ModalTitle>
                  <div className="form-group">
                    <label>Shto titullin:</label>
                    <input
                      required
                      id="name"
                      name="title_al"
                      type="text"
                      className="form-control"
                      placeholder="Loose weight"
                      onChange={handleChange}
                      defaultValue={props?.type === "edit" ? props?.dataToModal?.title_al : ""}
                    />
                  </div>
                  <div className="form-group mb-2">
                    <label>Add Title:</label>
                    <input
                      id="name"
                      name="title_en"
                      type="text"
                      placeholder="ex. Fitness Gloves"
                      className="form-control"
                      onChange={handleChange}
                      defaultValue={props?.type === "edit" ? props?.dataToModal?.title_en : ""}
                    />
                  </div>
                  <div className="form-group mb-2">
                    <label>Shto pershkrimin:</label>
                    <textarea
                      id="name"
                      name="description_al"
                      type="text"
                      className="form-control"
                      placeholder="Pershkrimi juaj"
                      onChange={handleChange}
                      defaultValue={props?.type === "edit" ? props?.dataToModal?.description_al : ""}
                      rows="4"
                      cols="11"
                    />
                  </div>
                  <div className="form-group mb-2">
                    <label>Add Description:</label>
                    <textarea
                      id="name"
                      name="description_en"
                      type="text"
                      className="form-control"
                      placeholder="ex. Lorem Ipsum"
                      onChange={handleChange}
                      defaultValue={props?.type === "edit" ? props?.dataToModal?.description_en : ""}
                      rows="4"
                      cols="11"
                    />
                  </div>
                  <div className="form-group mb-2">
                    <label>Choose Category:</label>
                    <select
                      required
                      id="name"
                      name="training_lessons_cat"
                      className="form-control"
                      onChange={handleChange}
                      value={props?.type === "edit" ? selectedCategory : null}
                    >
                      <option selected value="">Select Category</option>
                      {trainingLessonCategories?.map((el) => (
                        <option key={el?.id} value={el?.id} selected={props?.dataToModal?.training_lessons_cat === el.id ? true : false}>
                          {el?.name_al}
                        </option>
                      ))}
                    </select>
                  </div> 
                 
                  {props?.type !== 'edit' || props?.training?.video == null ?
                   " " :  
                    <div className="form-group my-2">
                      <video  controls
                        style={{ width: '500px' }}
                        src={`${process.env.REACT_APP_UPLOADS + props?.training?.video}`}
                      >                   
                      </video>
                    </div> 
                   }
                    <div className="form-group my-2">
                      <label>Add video:</label><br/>
                      <input
                          type="file"
                          name="training_lessons"
                          onChange={video}
                      />
                    </div>
                  {/* {props?.type === "add" && (
                    <div className="form-group my-2">
                      <label>Add video:</label>
                      <input
                        type="file"
                        accept="video/*"
                        onChange={handleChange}
                        name="video"
                        className="ms-2"
                      />
                    </div>
                  )} */}
                  {/* {props?.type === "edit" && (
                    <div className="form-group my-2">
                      <label>Add Video:</label>
                      <input
                        type="file"
                        accept="video/*"
                        onChange={handleChange}
                        name="video"
                        className="ms-2 mb-2"
                      />
                      <div>
                        {props?.dataToModal?.video ? (
                          <span>{props?.dataToModal?.video}</span>
                        ) : (
                          <span>No video chosen</span>
                        )}
                      </div>
                    </div>
                  )} */}
                  
                  {props?.type === "add" && (
                    <SaveButtonModal type="submit" onClick={addTrainingLesson}>
                      Ruaj
                    </SaveButtonModal>
                  )}
                  {props?.type === "edit" && (
                    <SaveButtonModal onClick={editTrainingLesson} type="submit">
                      Ndrysho
                    </SaveButtonModal>
                  )}
                </Form>
              )}
              {isdelete &&
                <>
                  <DeleteMessage>
                    <ModalTitle deleteMessage>Deshironi te fshini te dhenat?</ModalTitle>
                    <DeleteButtonModal onClick={deleteTrainingLesson}>Fshij</DeleteButtonModal>
                  </DeleteMessage>
                </>
              }
            </Mymodal_wrapper>
          </ModalStyle>
        </ModalPortal>
      </>
    );
  } else {
    return null;
  }
};

export default TrainingLessonsModal;
